import { render, staticRenderFns } from "./AnnotationTypeRates.vue?vue&type=template&id=f143a00a&scoped=true"
import script from "./AnnotationTypeRates.vue?vue&type=script&lang=js"
export * from "./AnnotationTypeRates.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTypeRates.vue?vue&type=style&index=0&id=f143a00a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f143a00a",
  null
  
)

export default component.exports